var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 12.5C5.35001 12.5 2.54801 10.537 1.53501 8C2.54801 5.463 5.35001 3.5 8.00001 3.5C10.65 3.5 13.452 5.463 14.465 8C13.452 10.537 10.65 12.5 8.00001 12.5ZM15.4695 7.829C14.3645 4.791 11.154 2.5 8.00001 2.5C4.84601 2.5 1.63551 4.791 0.530506 7.829C0.489506 7.9395 0.489506 8.0605 0.530506 8.171C1.63551 11.209 4.84601 13.5 8.00001 13.5C11.154 13.5 14.3645 11.209 15.4695 8.171C15.5105 8.0605 15.5105 7.9395 15.4695 7.829Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C6.897 10 6 9.103 6 8C6 6.897 6.897 6 8 6C9.103 6 10 6.897 10 8C10 9.103 9.103 10 8 10ZM8 5C6.3455 5 5 6.3455 5 8C5 9.6545 6.3455 11 8 11C9.6545 11 11 9.6545 11 8C11 6.3455 9.6545 5 8 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardView);
export default __webpack_public_path__ + "static/media/dashboard-view.c68a037f15b1cc5ee2c917a411d4f47a.svg";
export { ForwardRef as ReactComponent };